// import i18n from "@/plugins/LanguageComponent"; // Import instance i18n
import i18n from "@/plugins/LanguageComponent"; // Pastikan i18n diimpor

export const RESPONSE_MAPPINGS = {
    // HTTP Status Codes
    HTTP: {
        OK: 200,
        CREATED: 201,
        BAD_REQUEST: 400,
        UNAUTHORIZED: 401,
        FORBIDDEN: 403,
        NOT_FOUND: 404,
        INTERNAL_SERVER_ERROR: 500,
    },

    // Backend Response Codes
    CODES: {
        SUCCESS: 0,
        INCORRECT_EMAIL_PASSWORD: 1,
        EMAIL_PHONE_NUMBER_REGISTERED: 2,
        PASSWORD_NOT_MATCH: 3,
        ALREADY_VERIFIED: 4,
        NEXT_VERIFICATION: 5,
        FAILED_SEND_VERIFICATION: 6,
        INVALID_VERIFICATION_CODE: 7,
        VERIFICATION_CODE_EXPIRED: 8,
        FAILED_SEND_EKEY: 10,
        GATEWAY_NOT_REGISTERED: 11,
        LOCK_NOT_REGISTERED: 12,
        EMAIL_PHONE_NUMBER_UNREGISTERED: 13,
        DONT_HAVE_ACCESS: 15,
        ALREADY_EXIST: 16,
        FAILED_DELETE: 17,
        FILE_TYPE_NOT_SUPPORTED: 18,
        TARGET_DATE_UNAVAILABLE: 19,
        ROOM_NOT_AVAILABLE: 35,
        MONTHLY_BOOKING_LOGIN_REQUIRED: 106,
        LOGIN_OTP_REQUIRED: 107,
        INVALID_LOGIN_OTP: 108,
        LOGIN_OTP_EXPIRED: 109,
        SSO_ACCOUNT_LINK_CONFLICT: 110,
        LOGIN_IDENTIFIER_NOT_REGISTERED: 111,
        GENERAL_ERROR: 1000,
        SYSTEM_ERROR: -1,
    },

    // Mapping Status and Messages
    MESSAGES: {
        200: {
            0: "errors.operationSuccessful",
            5: "errors.nextVerificationRequired",
        },
        201: {
            0: "errors.resourceCreated",
        },
        400: {
            1: "errors.incorrectEmailPassword",
            2: "errors.emailPhoneNumberRegistered",
            3: "errors.passwordsNotMatch",
            4: "errors.alreadyVerified",
            6: "errors.failedSendVerification",
            7: "errors.invalidVerificationCode",
            8: "errors.verificationCodeExpired",
            13: "errors.emailPhoneNumberUnregistered",
            14: "errors.invalidVerificationCode",
            18: "errors.fileTypeNotSupported",
            19: "errors.targetDateUnavailable",
            35: "errors.roomNotAvailable",
            47: "errors.cannotGeneratePin",
            52: "errors.cannotGetNewPinBeforeCheckIn",
            67: "errors.maxCleaningRequestReached",
            68: "errors.outsideStayPeriod",
            69: "errors.cleaningAlreadyRequested",
            70: "errors.mustCheckInBeforeRequestCleaning",
            75: "errors.noRequestToReject",
            76: "errors.cannotRejectInProgressCleaning",
            77: "errors.youAlreadyCheckout",
            54: "errors.passwordNotSet",
            107: "errors.loginOtpRequired",
            108: "errors.invalidLoginOtp",
            109: "errors.loginOtpExpired",
            110: "errors.ssoAccountLinkConflict",
            111: "errors.loginIdentifierNotRegistered"
        },
        401: {
            15: "errors.unauthorizedAccess",
            106: "errors.monthlyBookingLoginRequired",
        },
        403: {
            106: "errors.monthlyBookingLoginRequired",
        },
        404: {
            17: "errors.resourceNotDeleted",
            64: "errors.settingNotFound",
            404: "errors.dataNotFound",
        },
        500: {
            "-1": "errors.systemError",
            53: "errors.failedToGetNewPin",
            1000: "errors.internalServerError",
        },
    },
};

// Default Message
export const DEFAULT_MESSAGE = "errors.defaultError";

/**
 * Mengambil pesan error berdasarkan status HTTP dan kode backend.
 * Mendukung penerjemahan menggunakan i18n.
 * @param {Number} status - Status HTTP dari response.
 * @param {Number} code - Kode dari backend.
 * @returns {String} - Pesan error yang diterjemahkan.
 */
export function getResponseMessage(status, code, returnKey = false) {
    // console.log("Received status:", status); // Debug status
    // console.log("Received code:", code); // Debug code

    const statusMessages = RESPONSE_MAPPINGS.MESSAGES[status];
    if (!statusMessages) {
        console.warn("No messages found for status:", status);
        return returnKey ? "errors.defaultError" : DEFAULT_MESSAGE;
    }

    const messageKey = statusMessages[code];
    if (!messageKey) {
        console.warn("No message found for code:", code, "in status:", status);
        return returnKey ? "errors.defaultError" : i18n.global.t(DEFAULT_MESSAGE);
    }

    return returnKey
        ? messageKey // Jika `returnKey` true, kembalikan key
        : i18n.global.t(messageKey); // Jika `returnKey` false, kembalikan pesan terjemahan
}
